<script setup lang="ts">
	const emit = defineEmits(['showOrderRequest']);

	const { menus } = useMenus();
	const isOpen = ref(false);

	const blockScroll = () => {
		const scrollbarWidth = window.innerWidth - document.documentElement?.clientWidth;
		document.body.style.setProperty('--padding-instead-scroll', `${scrollbarWidth}px`);
		document.body.style.overflow = 'hidden';
	};

	const unblockScroll = () => {
		document.body.style.overflow = '';
		document.body.style.setProperty('--padding-instead-scroll', `0px`);
	};

	const openMenu = () => {
		blockScroll();
		isOpen.value = true;
	};

	const closeMenu = () => {
		unblockScroll();
		isOpen.value = false;
	};

	const handleOrderRequest = () => {
		emit('showOrderRequest');
		closeMenu();
	};
</script>

<template>
	<div>
		<button type="button" class="header-burger" aria-label="Показать меню" @click="openMenu">
			<Icon name="local:burger" class="header-burger__icon" />
		</button>

		<transition name="fade">
			<div v-if="isOpen" class="modal-overlay" @click="closeMenu"></div>
		</transition>

		<transition name="slide">
			<div v-if="isOpen" class="modal">
				<div class="menu-header">
					<NuxtLink to="/" class="menu-header__link-logo" @click="closeMenu">
						<NuxtImg src="/images/svg/logo.svg" alt="logo" preload class="menu-header__logo" />
					</NuxtLink>
					<button class="menu-header__close-button" @click="closeMenu">
						<Icon name="local:close" class="menu-header__close-icon" />
					</button>
				</div>

				<div class="menu-content">
					<ul aria-label="Основная навигация" class="menu-content__menu-list">
						<li v-for="menuItem in menus" :key="menuItem.title" class="menu-list__item">
							<NuxtLink
								:to="menuItem.path"
								class="menu-list__item-link link"
								@click="closeMenu"
							>
								{{ menuItem.title }}
							</NuxtLink>
						</li>
					</ul>

					<div class="menu-content__br"></div>

					<div class="menu-content__contacts">
						<a :href="CONTACTS.phone.link" class="contacts__Item" @click="closeMenu">
							{{ CONTACTS.phone.text }}
						</a>
						<a :href="CONTACTS.email.link" class="contacts__Item" @click="closeMenu">
							{{ CONTACTS.email.text }}
						</a>
					</div>
				</div>

				<button type="button" class="button" @click="handleOrderRequest">Написать нам</button>
			</div>
		</transition>
	</div>
</template>

<style lang="scss" scoped>
	.header-burger {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		@media (pointer: fine) {
			&:hover {
				color: var(--color-secondary-dark);
			}
		}
		&:active {
			color: var(--color-secondary);
		}
	}
	.header-burger__icon {
		height: 27px;
		width: 40px;
	}

	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1000;
		opacity: 1;
		transition: opacity linear 0.2s;
	}

	.modal {
		position: fixed;
		display: flex;
		flex-direction: column;
		top: 0%;
		right: 0%;
		transform: translate(0%, 0%);
		background: white;
		padding: 15px;
		z-index: 1001;
		max-height: 100vh;
		max-height: 100dvh;
		height: 100%;
		max-width: 400px;
		width: 100%;
		overflow-y: auto;
		transition: transform linear 0.2s 0s;
	}

	.menu-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 47px;
		.menu-header__link-logo {
			display: flex;
			align-self: center;
			width: 218px;
			height: 28px;
		}
		.menu-header__logo {
			width: 218px;
		}
		.menu-header__close-button {
			cursor: pointer;
			display: flex;
			background: none;
			border: none;
			padding: 5px;
			margin-top: -5px;
			margin-bottom: -5px;
		}
		.menu-header__close-icon {
			width: 27px;
			height: 27px;
		}
	}

	.menu-content {
		flex: 1 0 auto;
		display: flex;
		flex-direction: column;
		gap: 25px;
		margin-bottom: 25px;
		.menu-content__menu-list {
			display: grid;
			gap: 15px;
		}
		.menu-list__item-link {
			width: fit-content;
			font-size: 30px;
			font-weight: 700;
		}
		.menu-content__br {
			height: 2px;
			width: 100%;
			background-color: var(--color-tertiary);
		}
		.menu-content__contacts {
			display: grid;
			gap: 15px;
		}
		.contacts__Item {
			cursor: pointer;
			width: fit-content;
			font-size: 22px;
			font-weight: 700;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		opacity: 0;
	}
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.slide-enter-active,
	.slide-leave-active {
		transform: translate(100%, 0%);
	}
	.slide-enter,
	.slide-leave-to {
		transform: translate(100%, 0%);
	}
</style>
